import select2 from 'select2/dist/js/select2.full';
window.select2 = select2();
